import { MapController } from "./controllers/MapController";
import {SearchController} from "./controllers/SearchController";

document.addEventListener('DOMContentLoaded', () => {
  const mapOthoptiste = document.getElementById('mapbox-orthoptiste');
  if ( mapOthoptiste ) {
    new MapController();
  }

  const searchbarOrthoptiste = document.getElementById('search-bar-orthoptiste');
  if ( searchbarOrthoptiste ) {
    new SearchController();
  }
});
